import React, {Component} from "react";
import Column from "@amzn/meridian/column";
import SelectLayout, {NavigationRoutes} from "../../util/SelectLayout";
import {ASML_SUB_COMPONENT_VALIDATION_ROUTES} from "../../util/RouteConstants";

class AsmlProtocolValidationSubComponentSelectionPage extends Component {
    render() {
        return (
            <Column>
                <SelectLayout routes={ASML_SUB_COMPONENT_VALIDATION_ROUTES.sort((a,b) => {
                    return a.name.localeCompare(b.name);
                })} location={this.props.location} history={this.props.history} isComponentTypeSelect={"true"}/>
                <NavigationRoutes routes={ASML_SUB_COMPONENT_VALIDATION_ROUTES}/>
            </Column>
        )
    }
}

export default AsmlProtocolValidationSubComponentSelectionPage


// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/AsmlProtocolValidationSubComponentSelectionPage.js